<template>
  <t-default-entry-sidebar
    v-if="sidebarInfo"
    :sidebar-list="sidebarInfo.sidebarList"
    :sidebar-current="sidebarInfo.sidebarCurrent"
    :heading="sidebarInfo.heading"
    :sub-heading="sidebarInfo.subHeading"
    :sidebar-heading="sidebarInfo.sidebarHeading"
    :sidebar-sub-heading="sidebarInfo.sidebarSubHeading"
    :class="componentClassName"
  >
    <form v-if="show_form" class="t-application-invite-user-summary__form" @submit.prevent="handleSubmitForm">
      <div class="t-application-invite-user-summary__fields">
        <m-application-summary>
          <template v-for="(item, index) in summaryList" :key="index">
            <a-application-summary-item :title="item.title" :variant="item.variant" :notes="item.notes">
              <!-- eslint-disable-next-line vue/no-v-html -->
              <div v-html="item.description" />
            </a-application-summary-item>
          </template>
        </m-application-summary>
      </div>
      <div class="t-application-invite-user-summary__buttons">
        <m-button-container>
          <a-button
            id="next"
            variant="block"
            submit="submit"
            color="primary"
            :disabled="hasErrorflg || !flagApplyButtonEnable"
            >この内容で申し込む</a-button
          >
          <a-button id="back" color="primary" @click="handleCancelClick">戻る</a-button>
        </m-button-container>
      </div>
    </form>
    <teleport to="body">
      <o-modal
        id="trialApplicationInviteUserSum_resultModal"
        v-model:visible="resultModalVisible"
        class="o-modal-remove-phone-number-confirmation"
        footer-variant="confirmation"
        width="442px"
        :footer-shadow="false"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="false"
      >
        <template #title>{{ resultModalTitle }}</template>
        <a-text>
          <!-- eslint-disable -->
          <span v-html="resultModalContent" />
          <!-- eslint-enable -->
        </a-text>
        <template #footer>
          <a-button id="ok" variant="block" color="primary" label="OK" size="small" @click="handleCloseModal" />
        </template>
      </o-modal>
    </teleport>
  </t-default-entry-sidebar>
</template>

<script>
import { mapModifiers } from '@/libs/component';
import TDefaultEntrySidebar from '@/components/templates/default-entry-sidebar';
import MApplicationSummary from '@/components/molecules/application-summary';
import AApplicationSummaryItem from '@/components/atoms/application-summary-item';
import AButton from '@/components/atoms/button';
import MButtonContainer from '@/components/molecules/button-container';

import { messageContent } from '@/common/messageContent.js';
import OModal from '@/components/organisms/modal';
import { customRequest } from '@/common/customRequest.js';
import { TRIAL_SIGNUP_RELIEF_MEASURES_PATH } from '@/libs/constants';
import { utils } from '@/common/utils.js';

export default {
  name: 't-trial-application-invite-user-summary',
  components: {
    TDefaultEntrySidebar,
    MApplicationSummary,
    AApplicationSummaryItem,
    AButton,
    MButtonContainer,
    OModal,
  },
  mixins: [messageContent, customRequest],
  props: {
    class: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      hasErrorflg: false,
      sidebarInfo: {
        sidebarList: [{ label: 'トライアル情報の入力' }, { label: 'トライアル内容確認' }],
        sidebarCurrent: 2,
        heading: 'トライアル内容確認',
        subHeading: 'Step 2',
        sidebarSubHeading: 'Trial',
        sidebarHeading: 'トライアルお申し込み',
      },
      summaryContract: {
        title: '契約名義種別',
        description: '法人名義のお申し込み',
      },
      summaryList: [],
      resultModalTitle: '',
      resultModalContent: '',
      resultModalVisible: false,
      show_form: false,
      summaryCompany: false,
      flagApplyButtonEnable: true, //#1892
      tmpUUID: '',
      tmpYMD: '',
      csrfToken: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
      devCompanyIDPrefixes: ['003', '004', '005'],
      companyIDList: [],
      trialData: {
        companyID: '',
        key: '',
        companyName: '',
        adminName: '',
        adminKanaName: '',
        adminPhoneNumber: '',
        adminEmail: '',
        adminLastName: '',
        adminNameView: '',
        adminLastKanaName: '',
        adminKanaNameView: '',
      },
    };
  },
  computed: {
    componentClassName() {
      const baseClassName = mapModifiers('t-application-invite-user-summary', this.variant);
      return `${baseClassName} ${this.class}`.trim();
    },
  },
  async mounted() {
    document.title = 'トライアル内容確認 | COTOHA Call Center';

    utils.setMetaDescription(this.$route);
    await this.getCookie('tmpUUID');
    await this.getCookie('tmpYMD');

    const tmpCompanyID = this.tmpUUID;
    if (typeof tmpCompanyID === 'undefined') {
      this.$router.push({ path: TRIAL_SIGNUP_RELIEF_MEASURES_PATH });
      return; // #2314
    }

    this.handlerFetchCompanyData();

    this.fetchTmpDataHandler();
    this.show_form = true;
  },
  methods: {
    async handleSubmitForm(e) {
      this.flagApplyButtonEnable = false; //#1892
      e.preventDefault();

      const prefixTriCompanyID = 'tri';
      const devCompanyIDPrefixes = this.devCompanyIDPrefixes;
      const companyIDList = this.companyIDList;
      let unique = false;
      let numstr = '';
      this.flagCreateEnable = false;

      if (this.projectEnv === 'production') {
        while (!unique) {
          numstr = this.randomNumStr(6);
          const numstrPrefix = numstr.slice(0, 3);
          if (devCompanyIDPrefixes.includes(numstrPrefix) || companyIDList.includes(prefixTriCompanyID + numstr)) {
            unique = false;
            numstr = '';
          } else {
            unique = true;
          }
        }
      } else {
        while (!unique) {
          const numstr1 = devCompanyIDPrefixes[Math.floor(Math.random() * devCompanyIDPrefixes.length)];
          const numstr2 = this.randomNumStr(3);
          numstr = numstr1 + numstr2;
          if (companyIDList.includes(prefixTriCompanyID + numstr)) {
            unique = false;
            numstr = '';
          } else {
            unique = true;
          }
        }
      }

      const companyID = prefixTriCompanyID + numstr;
      const res = await this.handleSendMail(companyID);
      return res;
    },
    handleSendMail(companyID) {
      const sendData = {};
      sendData.tmpUUID = this.tmpUUID;
      sendData.tmpYMD = this.tmpYMD;
      sendData.companyID = companyID;

      fetch('/signup/create', {
        method: 'POST',
        body: JSON.stringify({
          tmpUUID: this.tmpUUID,
          tmpYMD: this.tmpYMD,
          companyID: companyID,
          _csrf: this.csrfToken,
        }),
        headers: {
          'Content-Type': 'application/json',
        },
      })
        .then(response => {
          if (response.status === 403) {
            window.location.href = TRIAL_SIGNUP_RELIEF_MEASURES_PATH;
            return {};
          } else {
            return response.json();
          }
        })
        .then(e => {
          if (e.status === 'failed') {
            if (e.msg) {
              this.showErrorModal(e.msg);
            } else if (Array.isArray(e.errors)) {
              const errMsg = e.errors.map(e => e.msg).join('<br />');
              this.showErrorModal(errMsg);
            } else {
              this.showErrorModal(messageContent.requireTry('トライアル情報作成'));
            }
          } else {
            this.$router.push({ path: '/trial-signup/complete' });
          }
          return;
        })
        .catch(err => {
          console.log(err);
          this.showErrorModal(messageContent.requireTry('メール送信'));
          this.flagApplyButtonEnable = true; //#1892
        });
    },
    handleCancelClick() {
      this.$router.push({ name: 'TrialSignupForm', params: this.$route.params });
    },
    handleCloseModal() {
      this.resultModalVisible = false;
      this.resultModalTitle = '';
      this.resultModalContent = '';
    },
    showErrorModal(message) {
      this.resultModalVisible = true;
      this.resultModalTitle = messageContent.errorModalTitle;
      this.resultModalContent = message;
    },
    showInfoModal(message) {
      this.resultModalVisible = true;
      this.resultModalTitle = messageContent.infoModalTitle;
      this.resultModalContent = message;
    },
    getCookie: async function (key) {
      await this.postRequest('/signup/getCookie', { key: key })
        .then(e => {
          this[key] = e.cookie_value;
        })
        .catch(err => {
          console.log(err);
          this.showErrorModal(messageContent.requireTry('トライアル情報取得'));
        });
    },
    fetchTmpDataHandler: async function () {
      await this.postRequest('/signup/getCollection', {
        tmpCompanyID: this.tmpUUID,
        tmpYMD: this.tmpYMD,
        collectionType: 'historyCollection',
      })
        .then(e => {
          if (e.session) {
            const e_data = e.data;
            for (const key in e.data) {
              e_data[key] = e.data[key];
            }

            this.csrfToken = e.csrfToken;
            this.setCurrentValue(e_data);
          } else {
            window.location.href = '/login';
          }
        })
        .catch(err => {
          console.log(err);
          this.showErrorModal(messageContent.requireTry('トライアル内容確認'));
        });
    },
    setCurrentValue(val) {
      const title_individual = {
        adminName: '氏名',
        adminKanaName: '氏名カナ',
        companyName: '会社名',
        adminEmail: 'メールアドレス',
        adminPhoneNumber: '電話番号',
      };
      this.summaryList = [];

      let inputChk = 0;
      let i = 0;
      for (const key in title_individual) {
        if (key !== 'companyName') {
          if (val[key] === '') {
            inputChk = 1;
          }
        }

        if (i < 2) {
          val[key] = val[key].replace('_', ' ');
        }
        this.summaryList[i] = { title: title_individual[key], description: val[key] };
        i++;
      }

      if (inputChk === 1) {
        this.hasErrorflg = true;
        this.showErrorModal(messageContent.requireItemNotInput());
      }
    },
    handlerFetchCompanyData: function () {
      this.postRequest('/signup/getinitdata')
        .then(e => {
          if (e.status === 'success') {
            this.companyList = e.data;
            const companyIDList = [];
            for (let i = 0; i < e.data.length; i++) {
              companyIDList.push(e.data[i].companyID);
            }
            this.companyIDList = companyIDList;
            this.projectEnv = e.projectEnv;
          } else {
            this.showErrorModal(messageContent.requireTry('トライアル情報の取得'));
          }
        })
        .catch(() => {
          this.showErrorModal(messageContent.requireTry('トライアル情報の取得'));
        });
    },
    randomNumStr(length) {
      const content = '0123456789';
      const cl = content.length;
      let numStr = '';
      for (let i = 0; i < length; i++) {
        numStr += content[Math.floor(Math.random() * cl)];
      }
      return numStr;
    },
  },
};
</script>
